import styled from "styled-components";

export const ImgContainer = styled.div<{ heightImg: string }>`
  width: 100%;

  img {
    height: ${({ heightImg }) => heightImg || "100%"};
    max-width: 280px;
    max-height: 220px;
    width: 100%;
  }
`;
